import * as React from 'react';
import clsx from 'clsx';
import { CreditCard } from 'lucide-react';
import { ProductDomain, ProductCloud, ProductWebhosting, ProductCertificate, ProductMailbox, ProductOther } from '@gandi/ui/icons';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "ProductIcon-root_e11kd"
};
var themes = {
  "default": "Svg-default_2zVnf",
  "grey": "Svg-grey_1RoIL",
  "orange": "Svg-orange_93o85",
  "red": "Svg-red_NO3mH",
  "green": "Svg-green_3hqoL",
  "purple": "Svg-purple_2TxOI",
  "blue": "Svg-blue_1Opk2",
  "primary": "Svg-primary_3HHk4"
};
const productTypeToIcon = {
  'credit-card': CreditCard,
  certificate: ProductCertificate,
  paas: ProductWebhosting,
  'mailbox-standalone': ProductMailbox,
  mailboxv2: ProductMailbox,
  cloud: ProductCloud,
  domain: ProductDomain,
  marketplace: ProductOther,
  corporate: ProductOther,
  tmch: ProductOther,
  domain_option: ProductOther
};
export const productToTheme = {
  'credit-card': 'grey',
  certificate: 'green',
  cloud: 'red',
  domain: 'blue',
  corporate: 'primary',
  domain_option: 'primary',
  mailboxv2: 'purple',
  'mailbox-standalone': 'purple',
  marketplace: 'primary',
  paas: 'orange',
  tmch: 'primary'
};
const ProductIcon = ({
  className,
  type
}) => {
  const Icon = (type && productTypeToIcon[type]) ?? ProductOther;
  const theme = productToTheme[type || 'domain_option'];
  return /*#__PURE__*/_jsx("span", {
    className: clsx(themes[theme], styles.root, className),
    children: /*#__PURE__*/_jsx(Icon, {})
  });
};
export default /*#__PURE__*/React.memo(ProductIcon);